<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="用户名:" label-width="100px">
					<el-input v-model="filters.logName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="手机号:" label-width="100px">
					<el-input v-model="filters.mobileNo" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="更改时间:" label-width="100px">
					<el-date-picker type="daterange" v-model="addTimes" value-format="yyyy-MM-dd" class="formItem"
						size="small"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data" height="calc(100vh - 210px)" border highlight-current-row v-loading="listLoading"
			@selection-change="(v) => { sels = v }" style="width: 100%;">
			<el-table-column prop="realName" label="用户姓名" width="100"></el-table-column>
			<el-table-column prop="logName" label="用户名" width="100"></el-table-column>
			<el-table-column prop="mobileNo" label="手机号" width="130"></el-table-column>
			<el-table-column prop="scoreNum" label="积分" width="75"></el-table-column>
			<!-- <el-table-column prop="scoreType" label="类型" width="150"></el-table-column> -->
			<el-table-column prop="addTime" label="积分更改时间" width="140"
				:formatter="$util.dateFormatEx"></el-table-column>
				<el-table-column prop="scoreReason" label="原因" min-width="250" show-overflow-tooltip></el-table-column>
			<!-- <el-table-column label="操作" min-width="160" ffixed="right">
				<template scope="scope">
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column> -->
		</el-table>

		<!--分页-->
		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
export default {
	components: {  pagination },
	data() {
		return {
			filters: {
				userId: '',
				mobileNo:'',
				logName:'',
				addTime: '',
				addTime2:'',
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			addTimes:[]
		}
	},
	methods: {
		//获取列表
		getGridData() {
			this.listLoading = true;
			this.$util.dealQueryDateRange(this.filters, this.addTimes, "addTime")
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/school/getuserscorerecordlist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/school/userscorerecorddel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
	},
	async created() {
		this.getGridData();
	}
}

</script>

<style scoped></style>
